import cleanedFilename from '~/util/cleanedFilename';

export default {
  ADD_NEW_TRIGGER: `${cleanedFilename(__filename)}-add-new-trigger`,
};
